import { Button } from "@mui/material";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	LoginContext,
	LoginContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";
import { useNavigate } from "react-router-dom";

export const ProfileButton: React.FC = () => {
	const { activeStep, onChangeStep, onReset } = useContext(
		MultistepContext
	) as MultistepContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;

	const { setIsCalledFromProfile } = useContext(
		LoginContext
	) as LoginContextValues;

	const profileStep = findComponentStep(selectedFlow!, "Profile");

	const navigate = useNavigate();
	const clearUrlParams = () => {
		navigate("/");
	};

	const handleClick = () => {
		if (activeStep === profileStep) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const paymentId = urlSearchParams.get("external_reference");
			if (paymentId) {
				clearUrlParams();
			}
			onReset();
			onChangeStep(0);
		} else {
			onChangeStep(profileStep);
			setIsCalledFromProfile(true);
		}
	};

	return (
		<Button
			variant="text"
			onClick={handleClick}
			sx={{ fontWeight: 400, alignItems: "center" }}
		>
			{activeStep === profileStep ? (
				<FormattedMessage id="profile.home" defaultMessage="Home" />
			) : (
				<FormattedMessage id="profile.myProfile" defaultMessage="Mi perfil" />
			)}
		</Button>
	);
};
